import React from 'react'
import img1 from '../../Assete/19283.jpg'
import img2 from '../../Assete/9846834.jpg'
import img3 from '../../Assete/jib.jpg'
import img4 from '../../Assete/8767132.jpg'
function WorkProsess() {
    return (
//         <section className="work-process-area">
//   <div className="container" data-aos="fade-down">
//     <div className="row">
//       <div className="col-12">
//         <div className="section-title text-center">
//           <h3 className="title">How It Work?</h3>
//           <div className="desc">
//             <p>Many desktop publishing packages and web page editors</p>
//           </div>
//         </div>
//       </div>
//     </div>
//     <div className="row">
//       <div className="col-12">
//         <div className="working-process-content-wrap">
//           <div className="working-col">
//             {/*== Start Work Process ==*/}
//             <div className="working-process-item">
//               <div className="icon-box">
//                 <div className="inner">
//                   <img className="icon-img" src="assets/img/icons/w1.png" alt="Image-HasTech" />
//                   <img className="icon-hover" src="assets/img/icons/w1-hover.png" alt="Image-HasTech" />
//                 </div>
//               </div>
//               <div className="content">
//                 <h4 className="title">Create an Account</h4>
//                 <p className="desc">It is long established fact reader distracted readable content</p>
//               </div>
//               <div className="shape-arrow-icon">
//                 <img className="shape-icon" src="assets/img/icons/right-arrow.png" alt="Image-HasTech" />
//                 <img className="shape-icon" src="assets/img/icons/right-arrow2.png" alt="Image-HasTech" />
//               </div>
//             </div>
//             {/*== End Work Process ==*/}
//           </div>
//           <div className="working-col">
//             {/*== Start Work Process ==*/}
//             <div className="working-process-item">
//               <div className="icon-box">
//                 <div className="inner">
//                   <img className="icon-img" src="assets/img/icons/w2.png" alt="Image-HasTech" />
//                   <img className="icon-hover" src="assets/img/icons/w2-hover.png" alt="Image-HasTech" />
//                 </div>
//               </div>
//               <div className="content">
//                 <h4 className="title">CV/Resume</h4>
//                 <p className="desc">It is long established fact reader distracted readable content</p>
//               </div>
//               <div className="shape-arrow-icon">
//                 <img className="shape-icon" src="assets/img/icons/right-arrow.png" alt="Image-HasTech" />
//                 <img className="shape-icon" src="assets/img/icons/right-arrow2.png" alt="Image-HasTech" />
//               </div>
//             </div>
//             {/*== End Work Process ==*/}
//           </div>
//           <div className="working-col">
//             {/*== Start Work Process ==*/}
//             <div className="working-process-item">
//               <div className="icon-box">
//                 <div className="inner">
//                   <img className="icon-img" src="assets/img/icons/w3.png" alt="Image-HasTech" />
//                   <img className="icon-hover" src="assets/img/icons/w3-hover.png" alt="Image-HasTech" />
//                 </div>
//               </div>
//               <div className="content">
//                 <h4 className="title">Find Your Job</h4>
//                 <p className="desc">It is long established fact reader distracted readable content</p>
//               </div>
//               <div className="shape-arrow-icon">
//                 <img className="shape-icon" src="assets/img/icons/right-arrow.png" alt="Image-HasTech" />
//                 <img className="shape-icon" src="assets/img/icons/right-arrow2.png" alt="Image-HasTech" />
//               </div>
//             </div>
//             {/*== End Work Process ==*/}
//           </div>
//           <div className="working-col">
//             {/*== Start Work Process ==*/}
//             <div className="working-process-item">
//               <div className="icon-box">
//                 <div className="inner">
//                   <img className="icon-img" src="assets/img/icons/w4.png" alt="Image-HasTech" />
//                   <img className="icon-hover" src="assets/img/icons/w4-hover.png" alt="Image-HasTech" />
//                 </div>
//               </div>
//               <div className="content">
//                 <h4 className="title">Save &amp; Apply</h4>
//                 <p className="desc">It is long established fact reader distracted readable content</p>
//               </div>
//               <div className="shape-arrow-icon d-none">
//                 <img className="shape-icon" src="assets/img/icons/right-arrow.png" alt="Image-HasTech" />
//                 <img className="shape-icon" src="assets/img/icons/right-arrow2.png" alt="Image-HasTech" />
//               </div>
//             </div>
//             {/*== End Work Process ==*/}
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>
// </section>

        <section className="work-process-area">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="section-title text-center">
                            <h3 className="home_page_section_title">How It Work?</h3>
                            <div className="desc">
                                <p className="home_page_section_description">Many desktop publishing packages and web page editors</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-5">
                    <div className="col-12">
                        <div className="working-process-content-wrap">
                            <div className="working-col">
                                {/*== Start Work Process ==*/}
                                <div className="working-process-item">
                                    <div className="icon-box">
                                       <img style={{width:"100%",height:"150px",objectFit:"cover"}} src={img1} alt='...'/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Add Your CV/<br/>Resume</h4>
                                        {/* <p className="desc">It is long established fact reader distracted readable content</p> */}
                                    </div>
                                    <div className="shape-arrow-icon">
                                        
                                        <img className="shape-icon" src="assets/img/icons/right-arrow2.png" alt="Image-HasTech" />
                                    </div>
                                </div>
                                {/*== End Work Process ==*/}
                            </div>
                            <div className="working-col">
                                {/*== Start Work Process ==*/}
                                <div className="working-process-item">
                                    <div className="icon-box">
                                        <img style={{width:"100%",height:"150px",objectFit:"cover"}} src={img2} alt='...'/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Analyze your data & modify it</h4>
                                        {/* <p className="desc">It is long established fact reader distracted readable content</p> */}
                                    </div>
                                    <div className="shape-arrow-icon">
                                        
                                        <img className="shape-icon" src="assets/img/icons/right-arrow2.png" alt="Image-HasTech" />
                                    </div>
                                </div>
                                {/*== End Work Process ==*/}
                            </div>
                            <div className="working-col">
                                {/*== Start Work Process ==*/}
                                <div className="working-process-item">
                                    <div className="icon-box">
                                       <img style={{width:"100%",height:"150px",objectFit:"cover"}} src={img3} alt='...'/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Find Your Job/<br/>Scholarship</h4>
                                        {/* <p className="desc">It is long established fact reader distracted readable content</p> */}
                                    </div>
                                    <div className="shape-arrow-icon">
                                        
                                        <img className="shape-icon" src="assets/img/icons/right-arrow2.png" alt="Image-HasTech" />
                                    </div>
                                </div>
                                {/*== End Work Process ==*/}
                            </div>
                            <div className="working-col">
                                {/*== Start Work Process ==*/}
                                <div className="working-process-item">
                                    <div className="icon-box">
                                        <img style={{width:"100%",height:"150px",objectFit:"cover"}} src={img4} alt='...'/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Apply through the link</h4>
                                        {/* <p className="desc">It is long established fact reader distracted readable content</p> */}
                                    </div>
                                    <div className="shape-arrow-icon d-none">
                                        
                                        <img className="shape-icon" src="assets/img/icons/right-arrow2.png" alt="Image-HasTech" />
                                    </div>
                                </div>
                                {/*== End Work Process ==*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default WorkProsess